export type GuestTrialSlug = 'btob' | 'illuminator' | 'gapfinder';

export type GuestTrialAccent = 'teal' | 'orange' | 'pink';

export interface GuestTrialProduct {
  slug: GuestTrialSlug;
  name: string;
  tagline: string;
  description: string;
  icon: string;
  accent: GuestTrialAccent;
  href: string;
  badge?: string;
}

export const GUEST_TRIAL_PRODUCTS: GuestTrialProduct[] = [
  {
    slug: 'illuminator',
    name: 'Illuminator',
    tagline: 'Do you even need primary research?',
    description:
      'Synthesises existing evidence and synthetic respondents to map your insights gaps — so you know in minutes whether new fieldwork is worth the spend.',
    icon: 'lightbulb',
    accent: 'teal',
    href: '/guest-brief-new-illuminator',
    badge: 'Start here',
  },
  {
    slug: 'btob',
    name: 'Built-to-Brief',
    tagline: 'Nine questions. One decision-ready brief.',
    description:
      'A ten-minute consultation that assembles your research brief as you answer — decision, audience, unknowns, and practical constraints.',
    icon: 'pencil alternate',
    accent: 'orange',
    href: '/guest-brief-builder',
    badge: 'Most used',
  },
  {
    slug: 'gapfinder',
    name: 'GapFinder',
    tagline: 'Stress-test the brief you already have.',
    description:
      'Runs your brief across 12 dimensions of coverage to find what is missing, vague, or misaligned — before you commit to fieldwork.',
    icon: 'search',
    accent: 'pink',
    href: '/guest-brief-new-gapfinder',
  },
];

export function guestTrialProduct(slug: GuestTrialSlug): GuestTrialProduct | undefined {
  return GUEST_TRIAL_PRODUCTS.find((p) => p.slug === slug);
}

export function guestTrialHref(slug: GuestTrialSlug): string {
  return guestTrialProduct(slug)?.href ?? '/guest-brief-new';
}

export const GUEST_TRIAL_STORAGE_KEY = 'guestTrialProduct';
export const GUEST_ILLUMINATOR_DRAFT_KEY = 'guestIlluminatorDraft';
export const GUEST_GAPFINDER_DRAFT_KEY = 'guestGapfinderDraft';
